import React from 'react'
import styles from '../components/componentsStyles/Stacks.module.css'
import StacksContent from '../components/stacksComponents/StacksContent'
import StacksLarea from '../components/stacksComponents/StacksLarea'

const Stacks = () => {
  return (
    <div className={styles.stackPage}>
      <div className={styles.horizontalScroll}></div>
        <StacksLarea/>
        <StacksContent/>
    </div>
  )
}

export default Stacks